module.exports = __webpack_public_path__ + "static/media/upParMeetTam.21e0ef2a.jpg";